export const PLAN_ORDER = { free: 0, pro: 1, premium: 2 };

export const isPaid = (user) => {
  const tier = user?.tier || "free";
  return tier === "pro" || tier === "premium";
};

export const hasPlan = (user, minimum = "pro") =>
  PLAN_ORDER[user?.tier || "free"] >= PLAN_ORDER[minimum];

export const planLabel = (tier) =>
  tier === "premium" ? "Premium" : tier === "pro" ? "Pro" : "Free";

export const goUpgrade = () => {
  window.location.assign("/pricing");
};
